export default {
  android: {
    light: {
      backgroundColor: "rgba(252, 248, 253, 0.5)",
      sortTextColor: undefined,
      titleColor: undefined,
      primary: undefined,
      cardColor: undefined,
      borderRadius: undefined,
      listItemDistance: undefined,
      combineListItems: undefined,
      bottomBorder: undefined,
      bottomBorderColor: undefined,
      paddingLeft: undefined,
      paddingRight: undefined,
    },
    dark: {
      backgroundColor: "rgba(19, 19, 22, 0.96)",
      sortTextColor: undefined,
      titleColor: undefined,
      primary: undefined,
      cardColor: undefined,
      borderRadius: undefined,
      listItemDistance: undefined,
      combineListItems: undefined,
      bottomBorder: undefined,
      bottomBorderColor: undefined,
      paddingLeft: undefined,
      paddingRight: undefined,
    },
  },
  iOS: {
    light: {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
      sortTextColor: undefined,
      titleColor: undefined,
      primary: undefined,
      cardColor: undefined,
      borderRadius: undefined,
      listItemDistance: undefined,
      combineListItems: undefined,
      bottomBorder: undefined,
      bottomBorderColor: undefined,
      paddingLeft: undefined,
      paddingRight: undefined,
    },
    dark: {
      backgroundColor: "rgba(0, 0, 0, 0.96)",
      sortTextColor: undefined,
      titleColor: undefined,
      primary: undefined,
      cardColor: undefined,
      borderRadius: undefined,
      listItemDistance: undefined,
      combineListItems: undefined,
      bottomBorder: undefined,
      bottomBorderColor: undefined,
      paddingLeft: undefined,
      paddingRight: undefined,
    },
  },
};
